import { defineAsyncComponent } from "vue";
import BlogDetailHeader from "./blog-detail-header.vue";
import Blogs from "./blogs.vue";
import CallToAction from "./call-to-action.vue";
import ContactBlock from "./contact-block.vue";
import DemoProductList from "./demo-product-list.vue";
// import FavoriteProducts from "./favorite-products.vue";
import Features from "./features.vue";
import HeroHeader from "./hero-header.vue";
import HomeCategories from "./home-categories.vue";
import Login from "./login.vue";
import ProductContact from "./product-contact.vue";
import ProductSpecifications from "./product-specifications.vue";
import PromoText from "./promo-text.vue";
import RecommendedProducts from "./recommended-products.vue";
import SpecsBlock from "./specs-block.vue";
import SubscribeForm from "./subscribe-form.vue";
import TextBlockExtended from "./text-block-extended.vue";
import TextBlock from "./text-block.vue";
import TitleBlock from "./title-block.vue";

// Innovadis custom components
import ImageBlock from "./innovadis/inno-image-block.vue";
import DealerLocatorMap from "./innovadis/inno-dealer-locator-map.vue";
import DealerLocator from "./innovadis/inno-dealer-locator.vue";
import FAQ from "./innovadis/inno-faq.vue";
import HtmlBlock from "./innovadis/inno-html-block.vue";
import Newsletter from "./innovadis/inno-newsletter.vue";
import InnoProductInfo from "./innovadis/inno-product-info.vue";
import CustomRelatedProducts from "./innovadis/inno-related-products-block.vue";
import TextImageBlock from "./innovadis/inno-text-image-block.vue";
import VideoBlock from "./innovadis/inno-video-block.vue";
import CallToActionWithImage from "./innovadis/inno-call-to-action-with-image.vue";

import type { Component } from "vue";

const Slider = defineAsyncComponent(() => import("./slider.vue"));
const ProductsBlock = defineAsyncComponent(() => import("./products-block.vue"));

// Innovadis custom. The registration of the components for the page builder is now in client-app/plugins/builder-preview/register-components.ts

export const templateBlocks: { [key: string]: Component } = {
  "text-block": TextBlock,
  "text-block-extended": TextBlockExtended,
  "blog-detail-header": BlogDetailHeader,
  "text-image-block": TextImageBlock,
  "image-block": ImageBlock,
  "product-info": InnoProductInfo,
  "product-contact": ProductContact,
  "product-specifications": ProductSpecifications,
  "call-to-action-with-image": CallToActionWithImage,
  "contact-block": ContactBlock,
  "promo-text": PromoText,
  "specs-block": SpecsBlock,
  features: Features,
  "call-to-action": CallToAction,
  "subscribe-form": SubscribeForm,
  products: ProductsBlock,
  newsletter: Newsletter,
  "dealer-locator-map": DealerLocatorMap,
  "title-block": TitleBlock,
  faq: FAQ,
  blogs: Blogs,
  "hero-header": HeroHeader,
  "demo-product-list": DemoProductList,
  "dealer-locator": DealerLocator,
  "home-categories": HomeCategories,
  login: Login,
  "video-block": VideoBlock,
  slider: Slider,
  "recommended-products": RecommendedProducts,
  "related-products": CustomRelatedProducts,
  "html-block": HtmlBlock,
};
